import React, { useState, useEffect } from "react";
import dashboardclasses from "../dashboard.module.css";
import { IoClose } from "react-icons/io5";
import { useForm } from "react-hook-form";
import { Services } from "../../Services";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import {
    pincodeRegex,
    validateEmptySpaces,
} from "../../Components/utils/validations";
function AddCategory(props) {
    const Navigate = useNavigate();
    const token = { Authorization: `token ${sessionStorage.getItem("token")}` };
    const {
        register,
        handleSubmit,
        reset,
        formState: { errors },
    } = useForm();

    useEffect(() => {
        if (props.editable) {
            reset({ ...props.editable });
        }
        const close = (e) => {
            if (e.key == "Escape") {
                console.log("close");
                props.setmodal(false);
                props.setEditable(false);
            }
        };
        window.addEventListener("keydown", close);
        return () => window.removeEventListener("keydown", close);
    }, []);

    const CancelHandler = (e) => {
        e.stopPropagation();
        props.setmodal(false);
        props.setEditable(false);
    };

    const openhandler = (e) => {
        e.stopPropagation();
    };

    const onSubmit = (data) => {
        if (!props.editable) {
            Services.addSociety(
                "POST",
                JSON.stringify({
                    ...data,
                    latitude: Number(data.latitude),
                    longitude: Number(data.longitude),
                }),
                token
            )
                .then((res) => {
                    props.tableload(false);
                    if (res.Status === 1) {
                        Navigate(`/societies?page=${1}`);
                        props.setpageCount(1);
                        props.setmodal(false);
                        props.getCategories();

                        toast.success(`${res.Message}`, {
                            position: "top-center",
                            autoClose: 1000,
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                        });
                    } else if (res.Status === 0) {
                        toast.error(`${res.Message}`, {
                            position: "top-center",
                            autoClose: 1000,
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                        });
                    }
                })
                .catch((err) => {
                    // alert(err);
                    props.tableload(false);
                    alert("something went wrong please try again");
                    console.log(err);
                });
        } else {
            Services.updateSociety(
                "PUT",
                JSON.stringify({
                    ...data,

                    latitude: Number(data.latitude),
                    longitude: Number(data.longitude),
                }),
                token,
                props.editable.societyId
            )
                .then((res) => {
                    props.tableload(false);
                    if (res.Status === 1) {
                        Navigate(`/societies?page=${1}`);
                        props.setpageCount(1);
                        props.setmodal(false);

                        props.setEditable(false);
                        props.getCategories();

                        toast.success(`${res.Message}`, {
                            position: "top-center",
                            autoClose: 1000,
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                        });
                    } else if (res.Status === 0) {
                        toast.error(`${res.Message}`, {
                            position: "top-center",
                            autoClose: 1000,
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                        });
                    }
                })
                .catch((err) => {
                    // alert(err);
                    props.tableload(false);
                    alert("something went wrong please try again");
                    console.log(err);
                });
        }
    };
    return (
        <div className={dashboardclasses.modal} onClick={CancelHandler}>
            <div
                className={dashboardclasses["modal-content"]}
                onClick={openhandler}>
                <div className={dashboardclasses["modal-content-header"]}>
                    <div>
                        <h3>
                            {props.editable
                                ? "Update Society "
                                : "Add Society "}
                        </h3>
                        <p>
                            {props.editable
                                ? "Update Society "
                                : "Add Society "}{" "}
                            and necessary information from here
                        </p>
                    </div>
                    <button
                        className={dashboardclasses["close-btn"]}
                        onClick={CancelHandler}>
                        <IoClose size={22} color={"red"} />
                    </button>
                </div>
                <form
                    className={dashboardclasses["add-items"]}
                    onSubmit={handleSubmit(onSubmit)}>
                    <div className={dashboardclasses["item-image-upload"]}>
                        <label htmlFor="categoryname">Society Name</label>
                        <div className={dashboardclasses["select"]}>
                            <input
                                {...register("societyName", {
                                    required: "Society Name is required",
                                    validate: validateEmptySpaces,
                                })}
                            />
                            {errors?.societyName && (
                                <p className={dashboardclasses["error"]}>
                                    {errors?.societyName?.message}
                                </p>
                            )}
                        </div>
                    </div>
                    <div className={dashboardclasses["item-image-upload"]}>
                        <label htmlFor="categoryname">society Area</label>
                        <div className={dashboardclasses["select"]}>
                            <input
                                {...register("societyArea", {
                                    required: "Society area is required",
                                    validate: validateEmptySpaces,
                                })}
                            />
                            {errors?.societyArea && (
                                <p className={dashboardclasses["error"]}>
                                    {errors?.societyArea?.message}
                                </p>
                            )}
                        </div>
                    </div>
                    <div className={dashboardclasses["item-image-upload"]}>
                        <label htmlFor="categoryname">Address</label>
                        <div className={dashboardclasses["select"]}>
                            <input
                                {...register("address", {
                                    required: "Address is required",
                                    validate: validateEmptySpaces,
                                })}
                            />
                            {errors?.address && (
                                <p className={dashboardclasses["error"]}>
                                    {errors?.address?.message}
                                </p>
                            )}
                        </div>
                    </div>
                    <div className={dashboardclasses["item-image-upload"]}>
                        <label htmlFor="categoryname">pincode</label>
                        <div className={dashboardclasses["select"]}>
                            <input
                                {...register("pincode", {
                                    required: "Pincode is required",
                                    validate: pincodeRegex,
                                })}
                            />
                            {errors?.address && (
                                <p className={dashboardclasses["error"]}>
                                    {errors?.pincode?.message}
                                </p>
                            )}
                        </div>
                    </div>
                    <div className={dashboardclasses["item-image-upload"]}>
                        <label htmlFor="categoryname">Latitude</label>
                        <div className={dashboardclasses["select"]}>
                            <input
                                type="number"
                                step={"0.0000000001"}
                                {...register("latitude", {
                                    required: "Latitude is required",
                                    validate: validateEmptySpaces,
                                })}
                            />
                            {errors?.latitude && (
                                <p className={dashboardclasses["error"]}>
                                    {errors?.latitude?.message}
                                </p>
                            )}
                        </div>
                    </div>
                    <div className={dashboardclasses["item-image-upload"]}>
                        <label htmlFor="categoryname">Longitude</label>
                        <div className={dashboardclasses["select"]}>
                            <input
                                type="number"
                                step={"0.0000000001"}
                                {...register("longitude", {
                                    required: "longitude is required",
                                    validate: validateEmptySpaces,
                                })}
                            />
                            {errors?.longitude && (
                                <p className={dashboardclasses["error"]}>
                                    {errors?.longitude?.message}
                                </p>
                            )}
                        </div>
                    </div>

                    {/* <div className={dashboardclasses["item-image-upload"]}>
                        <label htmlFor="status">Status</label>
                        <div className={dashboardclasses["select"]}>
                            <select
                                {...register("status", {
                                    required: "status is required",
                                })}>
                                <option value="Active">Active</option>
                                <option value="Inactive">Inactive</option>
                            </select>
                            {errors?.status && (
                                <p className={dashboardclasses["error"]}>
                                    {errors?.status?.message}
                                </p>
                            )}
                        </div>
                    </div> */}

                    <div className={dashboardclasses["add-btn"]}>
                        <button type="button" onClick={CancelHandler}>
                            Cancel
                        </button>
                        <button
                            type="submit"
                            className={dashboardclasses["add-category-btn"]}>
                            {props.editable ? "update" : "Add Society"}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}

export default AddCategory;
